import React from "react";
import { Container } from "@mui/system";
import { Grid, Typography, Box } from "@mui/material";
import globals from "./globals";

export default function ErrorPage() {

  return (
    <Container>
      <Grid container spacing={2} justifyContent="space-evenly" alignItems="center" sx={{ mt: 10 }}>
        <Grid item xs={10} sm={4}>
          <img src='/error_page_owl.webp' style={{ height: 300, width: 300 }}></img>
        </Grid>
        <Grid item textAlign={'center'} xs={10} sm={6}>
          <Typography sx={{ color: globals.colors.darkBlue, fontSize: 40, fontWeight: 'bold' }}>Страницата не е намерена!</Typography>
          <Typography sx={{ color: globals.colors.textColor, fontSize: 25, fontWeight: 'bold' }}>Причини да си тук:</Typography>

          <Grid container justifyContent={'flex-start'}>
            
            <Grid container sx={{ mt: 2 }}  verticalAlign="middle">
              <Box
                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                <img src={'/error_page_arrow.webp'} style={{ height: 40, width: 40 }}></img>
                <Typography sx={{ color: globals.colors.textColor, fontWeight: 'bold', ml: 1, fontSize: 18 }}>Страницата, която търсиш не е намерена</Typography>
              </Box>
            </Grid>

            <Grid container verticalAlign="middle">
              <Box
                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                <img src={'/error_page_arrow.webp'} style={{ height: 40, width: 40 }}></img>
                <Typography sx={{ color: globals.colors.textColor, fontWeight: 'bold', ml: 1, fontSize: 18 }}>Страницата, която търсиш вече не съществува</Typography>
              </Box>
            </Grid>

            <Grid container verticalAlign="middle">
              <Box
                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                <img src={'/error_page_arrow.webp'} style={{ height: 40, width: 40 }}></img>
                <Typography sx={{ color: globals.colors.textColor, fontWeight: 'bold', ml: 1, fontSize: 18 }}>Изписваш грешен URL адрес</Typography>
              </Box>
            </Grid>

          </Grid>

        </Grid>
      </Grid>
    </Container>
  );
}